import { User, UserRole } from '../../types';

export default function isOwnerUser(user: User): boolean {
  return user.role === UserRole.OWNER;
}
